import { Modal, Select, Input, Button, message, AutoComplete } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import { http } from "../../../services/http";
import { useQuery } from "@tanstack/react-query";
import { debouncedSet } from "../../../utils/debounce";
import {
  formatNumberWithSpaces,
  removeSpaces,
} from "../../../utils/numberWithSpaces";
import moment from "moment";

const AddConversionModal = ({ visible, data, onClose, refetch }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [docDate, setDocDate] = useState(moment().format("YYYY-MM-DD"));
  const [docType, setDocType] = useState("");
  const [bpName, setBpName] = useState("");
  const [bpCode, setBpCode] = useState("");
  const [bpCurrency, setBpCurrency] = useState("");
  const [currency, setCurrency] = useState("");
  const [paymentSumBp, setPaymentSumBp] = useState("");
  const [intConv, setIntConv] = useState("");
  const [bpNameSearch, setBpNameSearch] = useState("");

  const paymentFor = [
    { value: "A", label: t("account") },
    { value: "S", label: t("supplier") },
  ];

  const fetchBpName = async ({ queryKey }) => {
    const [_, cardName] = queryKey;
    try {
      const { data } = await http.get(
        `api/bankstatements/business-partners?cardName=${cardName}`,
      );
      return data;
    } catch (err) {
      message.error(err?.response?.data?.message);
    }
  };

  const fetchExchangeRatesRUB = async ({ queryKey }) => {
    const [_, docDate] = queryKey;
    try {
      const { data } = await http.get(
        `api/cashier/currency-rate?Currency=руб&Date=${docDate}`,
      );
      const sapRate = data.data;
      return sapRate;
    } catch (err) {
      message.error(err?.response?.data?.message);
    }
  };

  const fetchExchangeRatesUSD = async ({ queryKey }) => {
    const [_, docDate] = queryKey;
    try {
      const { data } = await http.get(
        `api/cashier/currency-rate?Currency=UZS&Date=${docDate}`,
      );
      const sapRate = data.data;
      return sapRate;
    } catch (err) {
      message.error(err?.response?.data?.message);
    }
  };

  const { data: bpData = [], isLoading: bpIsLoading } = useQuery({
    queryKey: ["bp", bpNameSearch],
    queryFn: fetchBpName,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const { data: exchangeRatesUSD } = useQuery({
    queryKey: ["docRateUSD", docDate],
    queryFn: fetchExchangeRatesUSD,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const { data: exchangeRatesRUB } = useQuery({
    queryKey: ["docRateRub", docDate],
    queryFn: fetchExchangeRatesRUB,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const handleBtnClick = async () => {
    setLoading(true);
    const intentoryConv = removeSpaces(intConv);
    const sumBp = removeSpaces(paymentSumBp);
    const sapUsdToUzsRate = exchangeRatesUSD;
    const sapUsdToRubRate = exchangeRatesRUB;

    const rubRate = currency === "RUB" ? intentoryConv / sumBp : 0;

    const crossRate = currency === "RUB" ? sapUsdToUzsRate / rubRate : 0;
    const usdRate =
      currency === "USD" ? intentoryConv / sumBp : sapUsdToUzsRate;
    const paymSumCrosUsd = currency === "RUB" ? sumBp / crossRate : sumBp;

    console.log("paymSumCrosUsd = ", paymSumCrosUsd);
    console.log("usdRate = ", usdRate);
    console.log("crossRate = ", crossRate);
    console.log("rubRate = ", rubRate);
    console.log("sapUsdToRubRate = ", sapUsdToRubRate);
    console.log("sapUsdToUzsRate = ", sapUsdToUzsRate);

    const postData = [
      {
        lineId: 0,
        u_DocType: docType,
        u_BPOrAcctCode: bpCode,
        u_BPOrAcctName: bpName,
        u_DocCur: currency,
        u_IntConv: intentoryConv,
        u_PaymentSumBP: sumBp,
        u_CrossRate: crossRate,
        u_RubRate: rubRate,
        u_UsdRate: usdRate,
        u_PaymSumCrosUsd: paymSumCrosUsd,
        u_SapUsdToUzsRate: sapUsdToUzsRate,
        u_SapUsdToRubRate: sapUsdToRubRate,
        u_Status: "NOT_UPLOADED",
        u_DocDate: docDate,
      },
    ];

    try {
      const { data } = await http.post(`api/convertations/drafts`, postData);
      onClose();
      resetForm();
      refetch();
    } catch (err) {
      message.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setDocDate(moment().format("YYYY-MM-DD"));
    setDocType("");
    setBpName("");
    setBpCode("");
    setBpCurrency("");
    setCurrency("");
    setPaymentSumBp("");
    setIntConv("");
  };

  const handleBpSelect = (val, label) => {
    setBpName(label.cardName);
    setBpCode(val);
    setBpCurrency(label.currency);
    setBpNameSearch("");
  };

  const handleSearchBp = (val) => {
    debouncedSet(val, setBpNameSearch);
  };

  const handleBpChange = (val) => {
    setBpName(val);
    handleSearchBp(val);
  };

  const hanleDocTypeChange = (val) => {
    setDocType(val);
    setBpName("");
    setBpCode("");
    setBpCurrency("");
    setBpNameSearch("");
  };

  const handleCurrencyChange = (val) => {
    setCurrency(val);
  };

  return (
    <Modal
      title={
        <h1 className="mt-[-10px] font-sans text-xl font-extrabold text-[#000000]">
          {t("addConvertation")}
        </h1>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="45%"
      focusTriggerAfterClose={true}
      centered={true}
    >
      <div className="mt-7 w-full">
        <div className="flex flex-col gap-5">
          {/* DocDate DocType */}
          <div className="flex items-center justify-between gap-5">
            <div className="flex flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">{t("paymentType")}</p>
              <Select
                value={docType}
                onChange={hanleDocTypeChange}
                options={paymentFor}
                className="h-8 w-[200px]"
              />
            </div>
            <div className="flex flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">{t("date")}</p>
              <Input
                value={docDate}
                type="date"
                className="h-8 w-[200px] border-[1px] border-[#D0D0D0]"
                onChange={(e) => setDocDate(e.target.value)}
              />
            </div>
          </div>
          {/* Bp */}
          <div className="flex w-full flex-col items-start gap-2">
            <p className="font-semibold text-gray-700">{t("bp/Acc")}</p>
            <AutoComplete
              value={bpName}
              options={bpData
                .filter((item) => item.cardType === docType)
                .map((item) => ({
                  value: item.cardCode,
                  label: item.cardName,
                  cardName: item.cardName,
                  currency: item.currency,
                }))}
              disabled={!docType}
              className="w-full"
              onChange={(val) => {
                handleBpChange(val);
              }}
              loading={bpIsLoading}
              onSelect={(val, label) => {
                handleBpSelect(val, label);
              }}
            />
            {!docType && (
              <p className="text-red-500">{t("selectPaymentType")}</p>
            )}
          </div>
          {/* Currency BpCurrency */}
          <div className="flex items-end justify-between gap-5">
            <div className="flex w-full flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">
                {t("bpAccCurrency")}
              </p>
              <Input value={bpCurrency} className="h-8 w-full" disabled />
            </div>

            <div className="flex w-full flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">
                {t("convertationCurrency")}
              </p>
              <Select
                value={currency}
                onChange={handleCurrencyChange}
                options={[
                  { value: "USD", label: "USD" },
                  { value: "RUB", label: "RUB" },
                ]}
                className="w-full"
              />
            </div>
          </div>
          {/* Sum */}
          <div className="flex items-end justify-between gap-5">
            <div className="flex w-full flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">
                {t("paidSumConvertation")}
              </p>

              <Input
                value={formatNumberWithSpaces(intConv)}
                className="h-8 w-full border-[1px] border-[#D0D0D0]"
                onChange={(e) => {
                  const value = removeSpaces(e.target.value);
                  setIntConv(value);
                }}
                suffix={"UZS"}
              />
            </div>
            <div className="flex w-full flex-col items-start gap-2">
              <p className="font-semibold text-gray-700">{t("paidSumBp")}</p>

              <Input
                value={formatNumberWithSpaces(paymentSumBp)}
                className="h-8 w-full border-[1px] border-[#D0D0D0]"
                onChange={(e) => {
                  const value = removeSpaces(e.target.value);
                  setPaymentSumBp(value);
                }}
                suffix={currency}
              />
            </div>
          </div>
        </div>
        <Button
          type="primary"
          loading={loading}
          onClick={handleBtnClick}
          className="mt-10 w-full bg-basic text-white hover:!bg-blue-950"
        >
          {t("add")}
        </Button>
      </div>
    </Modal>
  );
};

export default AddConversionModal;
